import { render, staticRenderFns } from "./BasMaterialCategoryModal.vue?vue&type=template&id=a00d6be4&scoped=true&"
import script from "./BasMaterialCategoryModal.vue?vue&type=script&lang=js&"
export * from "./BasMaterialCategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./BasMaterialCategoryModal.vue?vue&type=style&index=0&id=a00d6be4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00d6be4",
  null
  
)

export default component.exports